import germanyFlagImage from '../assets/germanyflag.jpg';

/** Bundled local Germany flag — replaces every Unsplash/flagcdn remote URL. */
export const GERMANY_FLAG_IMAGE = germanyFlagImage;

export const isGermanyCode = (code?: string | null): boolean =>
  !!code && ['DE', 'DEU'].includes(code.toUpperCase());

/** Flag chip source: Germany always uses the bundled jpg, others pass through. */
export function resolveCountryFlag(code?: string | null, fallback?: string | null): string | undefined {
  if (isGermanyCode(code)) return GERMANY_FLAG_IMAGE;
  return fallback || undefined;
}

/**
 * Destination card/hero photo. This remains separate from flag resolution:
 * Germany's configured country photo must not be replaced by its flag.
 */
export function resolveCountryImage(
  code?: string | null,
  dbImage?: string | null,
  fallback?: string | null,
): string | undefined {
  void code;
  return dbImage || fallback || undefined;
}
